import { Button } from "@mui/material";
import type { ButtonProps } from "@mui/material";
import { Save as SaveIcon } from "@mui/icons-material";

/**
 * 공통 저장 버튼 프로퍼티
 *
 */
export type SaveButtonProps = Omit<
  ButtonProps,
  "variant" | "color" | "startIcon" | "minWidth"
> & {
  /**
   * 버튼 내부 컨텐츠
   * @type {React.ReactNode}
   */
  children?: React.ReactNode;
};

/**
 * 공통 저장 버튼
 *
 * @param {SaveButtonProps} props
 * @returns {JSX.Element}
 *
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @created 2025-01-15
 */
export const SaveButton = (props: SaveButtonProps) => {
  const { onClick, children, ...others } = props;

  return (
    <Button
      variant="contained"
      color="primary"
      disableElevation
      size="large"
      onClick={onClick}
      startIcon={<SaveIcon />}
      sx={{
        minWidth: 240,
      }}
      {...others}
    >
      {children}
    </Button>
  );
};
